// extracted by mini-css-extract-plugin
export default {"textarea":"p3ujt","textarea_width_default":"zVn4","textarea__caption":"ssPcA"};